module.exports = __webpack_public_path__ + "static/media/img6.402445d0.webp";